<template>
  <div>
    <hr class="separator-slim mx-6" v-if="isBoxVisible">
    <div class="search-filter-box p-6" v-show="isBoxVisible">
      <h4 class="fs-20 font-medium mb-4">
        Traveler rating
      </h4>

      <checkbox v-model="options.excellent"
                v-show="isRatingVisible([5])">
        Excellent
      </checkbox>
      <checkbox v-model="options.very_good"
                v-show="isRatingVisible([4])">
        Very Good
      </checkbox>
      <checkbox v-model="options.average"
                v-show="isRatingVisible([3])">
        Average
      </checkbox>
      <checkbox v-model="options.poor"
                v-show="isRatingVisible([2, 1])">
        Poor
      </checkbox>
      <checkbox v-model="options.unrated"
                v-show="isRatingVisible([0])">
        Unrated
      </checkbox>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import { mapState } from 'vuex'
import Checkbox from '../../../components/core/Checkbox'
import ClearFiltersMixin from '../../../mixins/ClearFiltersMixin'

export default {
  mixins: [ClearFiltersMixin],
  components: {
    Checkbox
  },
  data () {
    return {
      options: this.loadOptions()
    }
  },
  computed: {
    ...mapState(['statistics']),
    isBoxVisible () {
      return this.isRatingVisible([1,2,3,4,5])
    }
  },
  methods: {
    loadOptions () {
      const filters = this.$store.state.filters
      const ratingValues = filters.rating.split(',')

      const options = {
        excellent: ratingValues.includes('excellent'),
        very_good: ratingValues.includes('very_good'),
        average: ratingValues.includes('average'),
        poor: ratingValues.includes('poor'),
        unrated: ratingValues.includes('unrated')
      }

      return options
    },
    isRatingVisible (ratings) {
      return ratings.some(rating => {
        return get(this.statistics, ['visibleRatings', rating], false) === true
      })
    }
  },
  watch: {
    options: {
      deep: true,
      handler (options) {
        let newValue = []
        if (options.excellent) newValue.push('excellent')
        if (options.very_good) newValue.push('very_good')
        if (options.average) newValue.push('average')
        if (options.poor) newValue.push('poor')
        if (options.unrated) newValue.push('unrated')

        this.$store.commit('setFilter', {
          name: 'rating',
          value: newValue.join(',')
        })
        this.$store.dispatch('loadSuppliers')
      }
    }
  }
}
</script>
